import {ClampexType} from '../types/types';

interface ClampexPictures {
    productPicture: string,
    dimensioning: string,
    dimensioningAssembled: string
}


const getPicturePath = (clampexType: ClampexType): ClampexPictures => {
    switch(clampexType) {
        case ClampexType.KTR100:
            return {
                productPicture: require("../images/KTR100.jpg"),
                dimensioning: require("../images/08_100.png"),
                dimensioningAssembled: require("../images/08_100_einbau-1.png")
            }            
        case ClampexType.KTR105:
            return {
                productPicture: require("../images/KTR105.jpg"),
                dimensioning: require("../images/08_105.png"),
                dimensioningAssembled: require("../images/08_105_einbau-1.png")
            }       
        case ClampexType.KTR130:
            return {
                productPicture: require("../images/KTR130.jpg"),
                dimensioning: require("../images/08_130.png"),
                dimensioningAssembled: require("../images/08_130_einbau-1.png")
            }       
        case ClampexType.KTR131:
            return {
                productPicture: require("../images/KTR131.jpg"),
                dimensioning: require("../images/08_131.png"),
                dimensioningAssembled: ""
            }       
        case ClampexType.KTR200:
            return {
                productPicture: require("../images/KTR200.jpg"),
                dimensioning: require("../images/08_200.png"),
                dimensioningAssembled: require("../images/08_200_einbau-1.png")
            }  
        case ClampexType.KTR201:
            return {
                productPicture: require("../images/KTR201.jpg"),
                dimensioning: require("../images/08_201.png"),
                dimensioningAssembled: require("../images/08_201_einbau-1.png")
            }       
        case ClampexType.KTR203:
            return {
                productPicture: require("../images/KTR203.jpg"),
                dimensioning: require("../images/08_203.png"),
                dimensioningAssembled: require("../images/08_203_einbau-1.png")
            }       
        case ClampexType.KTR206:
            return {
                productPicture: require("../images/KTR206.jpg"),
                dimensioning: require("../images/08_206.png"),
                dimensioningAssembled: require("../images/08_206_einbau-1.png")
            }       
        case ClampexType.KTR225:
            return {
                productPicture: require("../images/KTR225.jpg"),
                dimensioning: require("../images/08_225.png"),
                dimensioningAssembled: require("../images/08_225_einbau-1-1.png")
            }       
        case ClampexType.KTR250:
            return {
                productPicture: require("../images/KTR250.jpg"),
                dimensioning: require("../images/08_250.png"),
                dimensioningAssembled: require("../images/08_250_einbau-1.png")
            }       
        case ClampexType.KTR400:
            return {
                productPicture: require("../images/KTR400.jpg"),
                dimensioning: require("../images/08_400.png"),
                dimensioningAssembled: require("../images/08_400_einbau-1.png")
            }       
        case ClampexType.KTR150:
            return {
                productPicture: require("../images/KTR150.jpg"),
                dimensioning: require("../images/08_150.png"),
                dimensioningAssembled: require("../images/08_150_einbau-1.png")
            }       
        case ClampexType.KTR700:
            return {
                productPicture: require("../images/KTR700.jpg"),
                dimensioning: require("../images/08_700.png"),
                dimensioningAssembled: require("../images/08_700_einbau-1.png")
            }                      
    }
}

export default getPicturePath;